import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { Footer } from "./Footer";

/**
 * App shell: the whole site lives inside a centered white panel (`.shell`) on a
 * gray "desktop", the way a personal homepage looked twenty-odd years ago.
 * A navy title band spans the top; below it a narrow left sidebar holds the
 * navigation and the routed content sits to its right; the footer spans the
 * full width. Also scrolls to the top on each navigation so deep pages don't
 * open mid-scroll.
 */
export function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  return (
    <div className="shell">
      <Header />
      <div className="body">
        <Sidebar />
        <main id="main">
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
}
